import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsOptional, IsUUID } from 'class-validator';
import { BumpResourceSheetPaidBatchInterface } from '../interfaces/bump-resource-sheet-paid-batch.interface';

/** Upper bound per row type of one "Mark as Paid" run; a Select all over a filtered sheet must fit. */
export const BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS = 1000;

const TOO_MANY_MESSAGE = `Too many rows selected to be processed (limit: ${BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS} rows per type).`;

/**
 * Both lists are optional and validated independently, so a malformed id in
 * one list is always caught even when the other list carries the selection.
 * The "at least one row" rule is enforced by the API when the action runs.
 */
export class BumpResourceSheetPaidBatchDto
  implements BumpResourceSheetPaidBatchInterface
{
  @ApiPropertyOptional({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Job Phase Bump IDs',
    description:
      'JOB_PHASE_BUMP rows to mark as paid. Rows already paid are skipped.',
    maxItems: BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS,
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS, {
    message: TOO_MANY_MESSAGE,
  })
  @IsUUID('all', { each: true })
  jobPhaseBumpIds?: string[];

  @ApiPropertyOptional({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Repair Payment IDs',
    description:
      'REPAIR_PAYMENT rows to mark as paid. Rows already paid are skipped.',
    maxItems: BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS,
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(BUMP_RESOURCE_SHEET_PAID_BATCH_MAX_ITEMS, {
    message: TOO_MANY_MESSAGE,
  })
  @IsUUID('all', { each: true })
  repairPaymentIds?: string[];
}
